import { render } from "./TableSightings.vue?vue&type=template&id=93cc735c&scoped=true"
import script from "./TableSightings.vue?vue&type=script&lang=js"
export * from "./TableSightings.vue?vue&type=script&lang=js"

import "./TableSightings.vue?vue&type=style&index=0&id=93cc735c&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93cc735c"]])

export default __exports__